const applicationModalGlobal = {
  // Returns false while no ApplicationModalGlobal is mounted, so callers can fall back to a navigation
  current: (_applicationId: number, _applicationIds: number[]) => false
}

export const getApplicationModalGlobalRef = (): typeof applicationModalGlobal =>
  applicationModalGlobal
